import { shallowEqual } from 'react-redux';

import { Button, ButtonGroup, Icon } from '@zillow/constellation-10';
import { IconHandshakeFilled } from '@zillow/constellation-icons';

import ConnectedModuleCard from '../../../ConnectedModuleCard';

import ManageTenantsCSEvents from '../../../../model/ClickstreamEvent/ManageTenantsCSEvents';

import {
  EmptyStateBodyText,
  EmptyStateTitleText,
  StyledEmptyStateContainer,
  StyledIconContainer,
} from '../../../../styles';
import { useSelector } from '../../../../selectors/useSelector';

type Props = {
  title: string;
  description: string;
  primaryCtaText: string;
  primaryCtaUrl: string;
  secondaryCtaText?: string;
  secondaryCtaUrl?: string;
};

const EmptyLeasesCard = ({
  title,
  description,
  primaryCtaText,
  primaryCtaUrl,
  secondaryCtaText = '',
  secondaryCtaUrl = '',
}: Props) => {
  const { user } = useSelector((state) => {
    return {
      user: state.user,
    };
  }, shallowEqual);

  const hasSecondaryCTA = !!(secondaryCtaText && secondaryCtaUrl);

  const handleEmptyLeasesCardPrimaryCTAClick = () => {
    ManageTenantsCSEvents.GetStarted({ user });
  };

  return (
    <ConnectedModuleCard data-testid="EmptyLeasesCard">
      <StyledEmptyStateContainer>
        <StyledIconContainer aria-hidden="true">
          <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconHandshakeFilled />} />
        </StyledIconContainer>

        {/* The title can be long.  Using responsive text styling to handle this */}
        <EmptyStateTitleText asChild>
          <h4>{title}</h4>
        </EmptyStateTitleText>

        <EmptyStateBodyText asChild>
          <p>{description}</p>
        </EmptyStateBodyText>

        <ButtonGroup
          aria-label="lease actions"
          orientation={{ base: 'vertical', md: 'horizontal' }}
          reverse={{ base: true, md: false }}
        >
          {hasSecondaryCTA && (
            <Button asChild tone="brand" emphasis="outlined" data-testid="EmptyLeasesCard-DefaultButton">
              <a href={secondaryCtaUrl}>{secondaryCtaText}</a>
            </Button>
          )}

          <Button
            asChild
            tone="brand"
            emphasis="filled"
            onClick={handleEmptyLeasesCardPrimaryCTAClick}
            data-eventid={ManageTenantsCSEvents.GetStarted.data_event_id}
          >
            <a href={primaryCtaUrl}>{primaryCtaText}</a>
          </Button>
        </ButtonGroup>
      </StyledEmptyStateContainer>
    </ConnectedModuleCard>
  );
};

export default EmptyLeasesCard;
